module.exports = __webpack_public_path__ + "static/img/main-slider-1-3.8b2797a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/main-slider-1-3.jpg
// module id = DU52
// module chunks = 1